import React from 'react';
import { Info, MessageSquare, ListTodo, MoreHorizontal } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useSidebar } from '@/context/SidebarContext';

interface MobileBottomNavProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const tabs = [
  { id: 'overview', label: 'Overview', icon: Info },
  { id: 'notes', label: 'Notes', icon: MessageSquare },
  { id: 'tasks', label: 'Tasks', icon: ListTodo },
];

const MobileBottomNav: React.FC<MobileBottomNavProps> = ({
  activeTab,
  onTabChange,
}) => {
  const { openSidebar } = useSidebar();
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t md:hidden safe-area-inset-bottom">
      <nav className="flex items-center justify-around h-16 max-w-screen-xl mx-auto px-safe">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              'flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset',
              activeTab === tab.id
                ? 'text-primary'
                : 'text-muted-foreground hover:text-foreground'
            )}
            aria-label={tab.label}
            aria-current={activeTab === tab.id ? 'page' : undefined}
          >
            <tab.icon className="h-5 w-5" aria-hidden="true" />
            <span className="text-xs font-medium">{tab.label}</span>
          </button>
        ))}
        
        {/* More button */}
        <button
          onClick={openSidebar}
          className={cn(
            'flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors',
            'text-muted-foreground hover:text-foreground',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset'
          )}
          aria-label="More options"
        >
          <MoreHorizontal className="h-5 w-5" aria-hidden="true" />
          <span className="text-xs font-medium">More</span>
        </button>
      </nav>
    </div>
  );
};

export default MobileBottomNav;
